import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Logo } from '@/components/ui/Logo';
import { useAuth } from '@/hooks/useAuth';

const primaryLinks = [
  { to: '/', label: 'Home' },
  { to: '/work', label: 'Work' },
  { to: '/services', label: 'Services' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];

const productLinks = [
  { to: '/cnc', label: 'KETIX3D CNC' },
  { to: '/floe-ai', label: 'FLOE AI — Coming Soon' },
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const { user, loading } = useAuth();

  return (
    <header className="sticky top-0 z-50 border-b border-line/60 bg-ink-950/80 backdrop-blur">
      <div className="container-page grid h-24 grid-cols-[auto_1fr_auto] items-center gap-6 md:grid-cols-[1fr_auto_1fr]">
        <Link to="/" onClick={() => setOpen(false)} className="justify-self-start">
          <Logo />
        </Link>

        <nav className="hidden items-center gap-9 justify-self-center md:flex">
          {primaryLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) =>
                `relative py-1 text-sm transition-colors ${
                  isActive ? 'text-signal' : 'text-paper-500 hover:text-paper-100'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {link.label}
                  {isActive && (
                    <span className="absolute -bottom-1 left-0 h-[2px] w-full rounded-full bg-signal shadow-[0_0_8px_rgba(62,123,250,0.8)]" />
                  )}
                </>
              )}
            </NavLink>
          ))}

          <div className="relative">
            <button
              type="button"
              onClick={() => setProductsOpen((v) => !v)}
              onBlur={() => setTimeout(() => setProductsOpen(false), 150)}
              className="text-sm text-paper-500 transition-colors hover:text-paper-100"
              aria-expanded={productsOpen}
            >
              Products
            </button>
            {productsOpen && (
              <div className="absolute right-0 top-8 w-56 rounded-xl border border-line bg-ink-900 p-2 shadow-xl">
                {productLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="block rounded-lg px-3 py-2 text-sm text-paper-300 hover:bg-ink-800 hover:text-paper-100"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            )}
          </div>
        </nav>

        <div className="hidden items-center gap-3 justify-self-end md:flex">
          {!loading && !user && (
            <>
              <Link to="/login" className="text-sm text-paper-300 hover:text-paper-100">
                Sign in
              </Link>
              <Link to="/contact" className="btn-primary">
                Start a project
              </Link>
            </>
          )}
          {!loading && user && (
            <Link to="/account" className="text-sm text-paper-300 hover:text-paper-100">
              Account
            </Link>
          )}
        </div>

        <button
          type="button"
          className="justify-self-end text-paper-100 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          {open ? '✕' : '☰'}
        </button>
      </div>

      {open && (
        <nav className="border-t border-line md:hidden">
          <div className="container-page flex flex-col gap-1 py-4">
            {[...primaryLinks, ...productLinks].map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2 text-sm text-paper-300 hover:bg-ink-800 hover:text-paper-100"
              >
                {link.label}
              </Link>
            ))}
            <div className="mt-2 flex flex-col gap-2 border-t border-line pt-4">
              {!user ? (
                <>
                  <Link to="/login" onClick={() => setOpen(false)} className="btn-secondary w-full">
                    Sign in
                  </Link>
                  <Link to="/contact" onClick={() => setOpen(false)} className="btn-primary w-full">
                    Start a project
                  </Link>
                </>
              ) : (
                <Link to="/account" onClick={() => setOpen(false)} className="btn-secondary w-full">
                  Account
                </Link>
              )}
            </div>
          </div>
        </nav>
      )}
    </header>
  );
}
